document.addEventListener("DOMContentLoaded", () => {
  const observePreorderButton = () => {
    const targetNode = document.body;
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === "childList") {
          const preorderButton = document.querySelectorAll(
            ".gPreorderBtn.gPreorderBtnLoaded"
          );
          if (preorderButton.length > 0) {
            const closeButton = document.querySelector("#pre-order__close");
            // Ensure the event listener is added only once
            preorderButton.forEach((e) => {
              e.removeEventListener("click", handleClick); // Remove any existing listeners
              e.addEventListener("click", handleClick);
            });
            closeButton.addEventListener("click", handleClick);

            observer.disconnect(); // Stop observing once the button is found
          }
        }
      });
    });

    observer.observe(targetNode, { childList: true, subtree: true });
  };
  const preOrderContainer = document.querySelector(".pre-order__container");
  const handleClick = () => {
    preOrderContainer.classList.toggle("pre-order__container-hide");
  };

  observePreorderButton();
});
